import { combineReducers } from 'redux';

import UserReducer from './user/user.reducer';
import DashboardReducer from './dashboard/dashboard.reducer';
import ListingReducer from './listing/listing.reducer';
import InquiriesReducer from './inquiries/inquiries.reducer';


let reducers = {
  user: UserReducer,
  dashboard: DashboardReducer,
  listing: ListingReducer,
  inquiries: InquiriesReducer
};

let rootReducer = combineReducers(reducers);

export default rootReducer;
